"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var cancel_drive_html_1 = __importDefault(require("./cancel-drive.html"));
var cancel_drive_controller_1 = __importDefault(require("./cancel-drive.controller"));
var moment_1 = __importDefault(require("moment"));
var time_1 = require("../../../common/helpers/time");
function getCancellationRules(UsersModel, $stateParams, UserService) {
    return UsersModel.getStudentCancellationRules($stateParams.id, UserService.getCurrentUser().id).then(function (response) {
        return response.data;
    });
}
getCancellationRules.$inject = ['UsersModel', '$stateParams', 'UserService'];
function getDriveSession($stateParams, DrivesModel) {
    return DrivesModel.getDriveByID($stateParams.id).then(function (response) {
        var drive = Object.assign(response.drive);
        var duration = (0, time_1.toHoursAndMinutes)(response.drive.session_length).split(':');
        var drive_date = (0, moment_1.default)(response.drive.drive_date + ' ' + response.drive.start_time, 'YYYY-MM-DD H:mm:ss');
        var start = (0, moment_1.default)(response.drive.drive_date + ' ' + response.drive.start_time, 'YYYY-MM-DD H:mm:ss');
        drive.drive_date = drive_date.format('MM/DD/YYYY');
        drive.start_time = start.format('h:mm A');
        drive.sessionLengthHours = duration[0];
        drive.sessionLengthMinutes = duration[1];
        return drive;
    });
}
getDriveSession.$inject = ['$stateParams', 'DrivesModel'];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state('drivecoach.student.drives.cancel', {
        url: '/cancel/:id',
        controller: cancel_drive_controller_1.default,
        controllerAs: 'vm',
        template: cancel_drive_html_1.default,
        resolve: {
            drive: getDriveSession,
            rules: getCancellationRules,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.student,
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];
exports.default = angular_1.default
    .module('student.drives.cancel', [])
    .config(config)
    .controller('StudentDrivesCancelController', cancel_drive_controller_1.default);
